import { GridValidRowModel, DataGridProProps } from '@mui/x-data-grid-pro';
import { Union } from 'ts-toolbelt';

import { TsrctAwardingStatusEntityVariant, TsrctAwardingStatusField, TsrctStatus } from '@/generated/gql/graphql.ts';
import {
  DemandAwardingData,
  DemandAwardingSettings,
  DemandAwardingStatus,
} from '~/modules/DemandAwardingWidget/DemandAwardingWidget.types';

export interface UseAwardingDataGridProps {
  negotiationCases?: Union.Nullable<DemandAwardingData[]>;
  awardingSettings?: Union.Nullable<DemandAwardingSettings>;
  status?: Union.Nullable<DemandAwardingStatus[]>;
  awardableConfirmedQuotes: boolean;
}
export interface AwardingDataGridRow {
  id: string;
  path: string[];
  type: AwardingDataGridRowType;
}

export type UseAwardingDataGridConfig<R extends GridValidRowModel = any> = (
  props: UseAwardingDataGridProps,
) => Pick<
  DataGridProProps<R>,
  | 'rows'
  | 'columns'
  | 'pinnedRows'
  | 'initialState'
  | 'groupingColDef'
  | 'getTreeDataPath'
  | 'isRowSelectable'
  | 'columnHeaderHeight'
>;

export enum AwardingDataGridField {
  ID = 'id',
  PRIORITY = 'priority',
}

export enum AwardingDataGridGroupType {
  STATUS = 'grpStatus',
  QUOTE = 'grpQuote',
  LINE_ITEMS = 'grpLineItems',
  SUPPLIER = 'grpSupplier',
}

export type AwardingDataGridGroup = `${AwardingDataGridGroupType}`;

export enum AwardingDataGridRowType {
  SUPPLIER = 'supplier',
  PROCESSED_BY = 'processedBy',
  STATUS = 'status',
  PROCESS_STATUS = 'processStatus',
  SUPPLIER_REFERENCE = 'supplierReference',
  DELIVERY_TIME_FRAME = 'deliveryTimeFrame',
  INITIAL_TOTAL = 'initialTotal',
  DISCOUNT = 'discount',
  FINAL_TOTAL = 'finalTotal',
  FINAL_TOTAL_WITH_TAXES = 'finalTotalWithTaxes',
  LINE_ITEM = 'lineItem',
  TOTAL_SPEND_PAST_YEAR = 'totalSpendPastYear',
  ORDERS_PAST_YEAR = 'ordersPastYear',
  ACTION = 'action',
  PURCHASE_ORDERS = 'purchaseOrders',
}

export type EntityStatusGetter = (args: {
  entityVariant: TsrctAwardingStatusEntityVariant;
  field: TsrctAwardingStatusField;
  entityId: string;
}) => TsrctStatus;
